import React from 'react';
import Layout from '../components/layout'
import Lesson from "../components/lesson";
import { Col, Row, Alert } from "react-bootstrap";
import SEO from "../components/seo";

export default function Teaching({ data }) {
  return (
    <Layout>
      <SEO title="Teaching"></SEO>
      <Row className='mb-3'>
        <Col>
          <h2 className='text-capitilize'>Econometrics - Advanced Methods</h2>
        </Col>
      </Row>
      <Row className="mb-3">
        <Col>
          <Alert variant='info'>
            <p>
              The teaching materials that were previously available on this webpage are being moved to Moodle. A Moodle page has been created, and all course materials will be uploaded there.
            </p>
            <p>
              If you have not received the enrollment information, please contact me by email using your campus email address.
            </p>
          </Alert>
        </Col>
      </Row>
      <Row>
        <Col>
          <h2 className='text-capitilize'>Past Teaching</h2>
        </Col>
      </Row>
      <Row>
        <Col>
          {data.allMarkdownRemark.edges.map(({ node }, index) => (
            <Lesson node={node} key={"T_" + index}></Lesson>
          ))
          }
        </Col>
      </Row>
    </Layout>
  )
}


export const query = graphql`
query Schooles {
  allMarkdownRemark(filter: {frontmatter: {layout: {eq: "school"}}}, sort: {fields: frontmatter___date, order: DESC}) {
    edges {
      node {
        id
        frontmatter {
          title
          date
          teaching {
            lessonTime
            lessonType
            lessonName
            isSeminar
            semester
          }
        }
      }
    }
  }
}

`